const groupPrefix = createApiRoute(ApiModule.CLIENT, ApiAuthorization.EMPLOYEE, ApiDataModel.MESSAGE)

export const apiClientMessages = {
	fetchClientMessages: async (clientUUID: string): Promise<IClientMessageModel[]> => {
		const { data } = await apiCommon<IClientMessage[]>(`${groupPrefix}`, {
			method: 'GET',
			params: {
				client_uuid: clientUUID,
			},
		})

		return data.map(d => ClientMessage(d))
	},

	fetchClientParticularMessage: async (messageUUID: string): Promise<IClientMessageModel> => {
		const { data } = await apiCommon<IClientMessage>(`${groupPrefix}/${messageUUID}`, {
			method: 'GET',
		})

		return ClientMessage(data)
	},

	createClientMessage: async (payload: IClientMessageCreateModel): Promise<IClientMessageModel> => {
		const body = ClientMessageManageToJson(payload)

		const { data } = await apiCommon<IClientMessage>(`${groupPrefix}`, {
			method: 'POST',
			body,
		})

		return ClientMessage(data)
	},
}
